var render = function render(){var _vm=this,_c=_vm._self._c;return _c('table',{staticClass:"w-100"},[_c('tbody',[_c('tr',[_c('td',{staticClass:"text-muted"},[_vm._v("HEX:")]),_c('td',{staticClass:"font-weight-bold"},[_vm._v(_vm._s(this.hexColor))])]),_c('tr',[_c('td',{staticClass:"text-muted"},[_vm._v("RGB:")]),_c('td',{staticClass:"font-weight-bold"},[_vm._v(_vm._s(this.bgColor))])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }